import { format } from "date-fns";

const DATE_WITH_YEAR = "d MMM yyyy";

export const formatDateRangeLabel = (
  range: { from?: Date; to?: Date },
  placeholder: string,
): string => {
  if (range.from && range.to) {
    return `${format(range.from, DATE_WITH_YEAR)} - ${format(range.to, DATE_WITH_YEAR)}`;
  }

  if (range.from) {
    return format(range.from, DATE_WITH_YEAR);
  }

  return placeholder;
};
